const kraManagementRoute = {
    BASE_PATH: "/kra-management",
    addPath: function() {
        return this.BASE_PATH + "/create"
    },
    editPath: function(id: string) {
        return `${this.BASE_PATH}/${id}/edit`
    }
}

export default kraManagementRoute;